import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";

// UI
import { CloseMenu, ContainerNew, MenuNone, openLayerFn } from "../Layout";

import {
  PostApi152,
  PostApi156,
  PostApi157,
  SendEmail,
} from "../../modules/network/padoPost";

import { AlertLayer, ConfirmLayer } from "../../components/UI/Dialog";
import { maxLengthCheck } from "../../modules/utils/CheckLogic";
import { NativeAction } from "../../modules/utils/HandleWs";
import { userHabit } from "../../modules/utils/UserHabit";
import { action_timer, fn_delTimer, TimeLimit } from "../common/Timer/timer";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);

  const handleNewPassword = () => {
    request157();
    // handleRequest152();
  };

  const request156 = () => {
    PostApi156(
      phonecfg,
      cfg,
      $('input[name="email"]').val(),
      $('input[name="name"]').val(),
      $('input[name="birth"]').val(),
      $('input[name="phone"]').val()
    ).then(res => {
      if (res.resultCode === "000") {
        if (res.result === 0) {
          handleAlert("", "입력정보를 확인하세요.");
        } else {
          handleAlert("", "인증번호가 발송되었습니다.");
          action_timer();
        }
      } else {
        handleNewPasswordFail();
      }
    });
  };

  const request157 = () => {
    PostApi157(
      phonecfg,
      cfg,
      $('input[name="email"]').val(),
      $('input[name="name"]').val(),
      $('input[name="birth"]').val(),
      $('input[name="phone"]').val(),
      $('input[name="attctNo"]').val()
    ).then(res => {
      if (res.resultCode === "000") {
        if (res.result === 1) {
          // handleAlert('', '성공');
          _O.OpenMenu(
            "/membership/changePwd/" +
              $('input[name="email"]').val() +
              "/" +
              $('input[name="attctNo"]').val()
          );
        } else {
          handleAlert("", "입력한 정보를 확인하세요.");
          // handleAlert('', '잘못된 인증번호입니다.');
          // 인증번호가 잘못되었을경우
          // 인증번호 발송이후 회원정보가 바뀐 경우
        }
      } else {
        handleNewPasswordFail();
      }
    });
  };

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleAlert = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".alert-layer"));
  };

  const handleAlertCB = () => {
    // handleReset();
  };

  const handleNewPasswordFail = () => {
    handleAlert(
      "",
      "등록한 정보와 일치하지 않습니다.<br />입력한 내용에 문제가 없는 경우 1877-4872로 문의하세요."
    );
  };

  const handleNewPasswordCancelCB = () => {
    // closeLayerFn($(".confirm-layer"));
    _O.OpenMenu("/");
  };

  const handleNewPasswordConfirmCB = () => {
    // closeLayerFn($(".confirm-layer"));
    _O.OpenMenu("/");
  };
  // 다이얼로그 ]]

  useEffect(() => {
    userHabit(phonecfg, "FP200");
    NativeAction(phonecfg, "statusColor", "#A5AEE4");
  }, [phonecfg.version]);

  useEffect(() => {
    fn_delTimer();
  }, []);

  return (
    <Fragment>
      <ContainerNew
        Title={"비밀번호 재설정"}
        dark={true}
        leftMenu={MenuNone}
        rightMenu={CloseMenu}
        gotoRightUrl={"/membership/login"}>
        <div className="login-pw-box">
          <div className="pw-inp-box" style={{ textAlign: "left" }}>
            {/* <span>비밀번호를 재설정합니다.</span> */}

            <div className="ninp">
              <input
                type="text"
                name="email"
                value={props.match.params.email}
                autoComplete="email"
                placeholder="아이디"
                readOnly
              />

              <input
                type="text"
                name="name"
                autoComplete="name"
                placeholder="성명"
                maxLength={20}
              />

              <input
                type="number"
                pattern="\d*"
                name="birth"
                autoComplete="off"
                placeholder="생년월일(8자리)"
                onChange={e => maxLengthCheck(e, 8)}
              />

              {/* <input type="radio" name="gender" value="1" /> 남 */}
              {/* <input type="radio" name="gender" value="2" /> 여 */}

              <input
                type="number"
                pattern="\d*"
                name="phone"
                autoComplete="off"
                placeholder="전화번호"
                onChange={e => maxLengthCheck(e, 11)}
                style={{
                  width: "60%",
                }}
              />

              <input
                type="button"
                name="sending"
                value="인증번호 받기"
                onClick={() => request156()}
                style={{
                  width: "36%",
                  float: "right",
                }}
              />

              <input
                type="text"
                name="attctNo"
                autoComplete="off"
                placeholder="인증번호"
                style={{
                  width: "60%",
                }}
                disabled
              />

              <TimeLimit />
            </div>
            <div className="g-un-txt">
              <i>!</i>
              가입시 지정한 이메일(아이디)로 비밀번호 재설정이 가능한 링크를
              공유드립니다.
            </div>

            <div className="btn">
              <a
                href={void 0}
                className="btn-linkmail-layer"
                onClick={e => handleNewPassword()}>
                확인
              </a>
            </div>
          </div>
        </div>
      </ContainerNew>

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={handleAlertCB}
      />

      <ConfirmLayer
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleNewPasswordCancelCB}
        handleConfirmCB={handleNewPasswordConfirmCB}
      />
    </Fragment>
  );
};
